import { render, staticRenderFns } from "./escaleta.vue?vue&type=template&id=37f1b6d2&scoped=true&"
import script from "./escaleta.vue?vue&type=script&lang=js&"
export * from "./escaleta.vue?vue&type=script&lang=js&"
import style0 from "./escaleta.vue?vue&type=style&index=0&id=37f1b6d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f1b6d2",
  null
  
)

export default component.exports